import { useKrakenQuery } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import { useAccountNumberContext } from '@/context/AccountNumberContext/withFetch/AccountNumberContext';
import { smartMeterReadingSchema } from '@/hooks/usage/validations';
import { MeasurementType } from '@/lib/charts';

import SmartMeterReadings from './SmartMeterReadings.graphql';

type UtilityFilter = {
  waterFilters?: {
    readingFrequencyType: string;
    marketSupplyPointId?: string | null;
    deviceId?: string | null;
  };
};

type SmartMeterReadingsResponse = {
  account: {
    properties: {
      activeWaterMeters: {
        capabilityType: string;
      }[];
      measurements: {
        edges: { node: MeasurementType }[];
      };
    }[];
  };
};

export const useSmartMeterMeasurements = ({
  startAt,
  endAt,
  utilityFilters,
  isEnabled,
  queryKey = 'smartMeterReadings',
}: {
  startAt: Date;
  endAt: Date | string;
  utilityFilters: UtilityFilter[];
  isEnabled: boolean;
  queryKey?: string;
}) => {
  const { isAuthenticated } = useAuth();
  const { accountNumber } = useAccountNumberContext();

  return useKrakenQuery({
    queryKey: [queryKey],
    query: SmartMeterReadings,
    select: (data: SmartMeterReadingsResponse) => {
      return {
        capabilityType:
          data.account.properties[0].activeWaterMeters[0]?.capabilityType,
        measurements: data.account.properties[0].measurements.edges,
      };
    },
    validateFn(response) {
      return smartMeterReadingSchema.validate(response);
    },
    enabled: Boolean(isAuthenticated && accountNumber && isEnabled),
    variables: { accountNumber, startAt, endAt, utilityFilters },
  });
};
